import styles from "./MenuItemTile.module.scss";

export interface MenuItemTileProps {
  name: string;
  description: string;
  price: string;
  dishImage?: string;
  /** Makes the tile tappable. Omitted on the browse-only menu. */
  onClick?: () => void;
  /** Units of this dish already in the cart. Hidden at 0. */
  count?: number;
}

function MenuItemTile(props: MenuItemTileProps) {
  const { name, description, price, dishImage, onClick, count = 0 } = props;

  const interactive = Boolean(onClick);

  return (
    <div
      className={`${styles.menuItemTileContainer} ${
        interactive ? styles.menuItemTileInteractive : ""
      }`}
      onClick={onClick}
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
    >
      <div className={styles.menuItemTileTextGroup}>
        <p className={`body-bold-medium ${styles.menuItemTileTitle}`}>{name}</p>
        <p className={`body-medium ${styles.menuItemTileDescription}`}>
          {description}
        </p>
        <div className={styles.menuItemTilePriceRow}>
          <p className={`body-medium ${styles.menuItemTilePrice}`}>{price} zł</p>
          {count > 0 ? (
            <div className={styles.menuItemTileCount}>
              <p className={`body-bold-small ${styles.menuItemTileCountValue}`}>
                {count}
              </p>
            </div>
          ) : null}
        </div>
      </div>
      {dishImage ? (
        <div className={styles.menuItemTileImagePlaceholder}>
          <img
            src={dishImage}
            alt={name}
            className={styles.menuItemTileImage}
          />
          <div />
        </div>
      ) : null}
    </div>
  );
}

export default MenuItemTile;
